<template>
  <span class="icon" :class="classObject" :style="styleObject"></span>
</template>

<script>
export default {
  name: "icon",
  props: {
    type: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 1
    },
    padding: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ""
    },
    opacity: {
      type: Number,
      default: null
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: ""
    }
  },
  computed: {
    classObject: function() {
      var classes = {};
      classes["icon-" + this.type] = true;
      if (this.rounded) {
        classes.rounded = true;
      }

      if (this.border) {
        classes.border = true;
      }
      return classes;
    },
    styleObject: function() {
      return {
        fontSize: this.size + "em",
        color: this.color,
        backgroundColor: this.rounded ? this.backgroundColor : "",
        padding: this.padding,
        borderColor: this.rounded ? this.borderColor : "",
        opacity: this.opacity,
        boxShadow: this.highlight ? "rgb(117, 154, 221) 0px 0px 0px 5px" : ""
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "bohemia-account";
  src: url("/static/icons/bohemia-account.eot");
  src: url("/static/icons/bohemia-account.eot?#iefix")
      format("embedded-opentype"),
    url("/static/icons/bohemia-account.woff") format("woff"),
    url("/static/icons/bohemia-account.ttf") format("truetype"),
    url("/static/icons/bohemia-account.svg#bohemia-account") format("svg");
  font-weight: normal;
  font-style: normal;
}

[data-icon]:before {
  font-family: "bohemia-account" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-family: "bohemia-account" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-account:before {
  content: "\61";
}
.icon-connect:before {
  content: "\62";
}
.icon-store:before {
  content: "\63";
}
.icon-check:before {
  content: "\64";
}
.icon-facebook:before {
  content: "\66";
}
.icon-twitter:before {
  content: "\67";
}
.icon-steam:before {
  content: "\68";
}
.icon-google-plus:before {
  content: "\69";
}
.icon-linkedin:before {
  content: "\6a";
}
.icon-youtube:before {
  content: "\6b";
}
.icon-question:before {
  content: "\6c";
}
.icon-info:before {
  content: "\6d";
}
.icon-external-link:before {
  content: "\6e";
}
.icon-right:before {
  content: "\6f";
}
.icon-next-right:before {
  content: "\70";
}
.icon-warning:before {
  content: "\71";
}
.icon-down:before {
  content: "\72";
}
.icon-camera:before {
  content: "\73";
}
.icon-x:before {
  content: "\65";
}
.icon-trash:before {
  content: "\74";
}
.icon-refresh:before {
  content: "\75";
}

.icon {
  color: inherit;
  display: inline-block;
  line-height: 1;
  transition: background-color 0.5s, color 0.5s;

  &.border {
    border: 1px solid #759add;
  }
}

.rounded {
  border-radius: 50%;
  padding: 1em;
  background-color: #759add;
  color: #fff;
  border: 1px solid transparent;

  &:hover {
    background-color: #c8d7f1 !important;
    color: #000;
  }
}

.icon-transparent:before {
  content: "";
  white-space: pre;
}
</style>
